var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import assign from './assign';
import { register } from './factory';
import { Thickness } from './ISeparator';
import Type from './Type';
export * from './ISeparator';
function isIOptions(init) {
    return typeof init === 'object' && init !== null;
}
function options(init) {
    return isIOptions(init) ? init : { thickness: init };
}
export class Generic {
    constructor(init = {}) {
        this.type = Type.Separator;
        const _a = options(init), {thickness, copy} = _a, rest = __rest(_a, [
                'thickness',
                'copy'
            ]);
        this.thickness = thickness || Thickness.Normal;
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.thickness.configurable = false;
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
}
export class Separator extends Generic {
}
export const klass = Separator;
export default Separator;
register(Type.Separator, Separator);    //# sourceMappingURL=Separator.js.map
